import React from 'react';

const PortalContext = React.createContext({
  namespace: null
});

PortalContext.displayName = 'PortalContext';

export default PortalContext;
